module.exports = __webpack_public_path__ + "img/iron-on-tags.3acb6f4f.png";